module.exports = __webpack_public_path__ + "img/avatar2.103542d0.png";